// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"organization_wrapper__xD_f8"};